// SEO-Helfer: JSON-LD-Snippets und Canonical-Tags dynamisch verwalten (SPA).

export const CANONICAL_BASE = "https://dickies-helden.de";

/** Fügt ein JSON-LD-Script mit fester ID ein bzw. ersetzt es. */
export function injectJsonLd(id, data) {
  let tag = document.getElementById(id);
  if (!tag) {
    tag = document.createElement("script");
    tag.id = id;
    tag.type = "application/ld+json";
    document.head.appendChild(tag);
  }
  tag.textContent = JSON.stringify(data);
}

export function removeJsonLd(id) {
  document.getElementById(id)?.remove();
}

/** Setzt <link rel="canonical"> und og:url auf die Produktions-Domain. */
export function setCanonical(pathname) {
  const href = `${CANONICAL_BASE}${pathname === "/" ? "/" : pathname.replace(/\/$/, "")}`;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = href;
  let og = document.querySelector('meta[property="og:url"]');
  if (!og) {
    og = document.createElement("meta");
    og.setAttribute("property", "og:url");
    document.head.appendChild(og);
  }
  og.content = href;
}
